
export const testimonials = [
  {
    text: 'Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life One day however a small.',
    customer_name: 'Louise Kelly',
    job: 'Illustrator Designer'
  },
  {
    text: 'Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life One day however a small line of blind text by the name of Lorem Ipsum decided to leave for the far World of Grammar.',
    customer_name: 'Louise Kelly',
    job: 'Illustrator Designer'
  },
  {
    text: 'Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life One day however a small line of blind text by the name.',
    customer_name: 'Louise Kelly',
    job: 'Illustrator Designer'
  },
  {
    text: 'Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life One day however.',
    customer_name: 'Louise Kelly',
    job: 'Illustrator Designer'
  },
  {
    text: 'Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life One day however a small line of blind text by the name. ',
    customer_name: 'Louise Kelly',
    job: 'Illustrator Designer'

  },
]
